/**
 * OnboardingPage - Container for the multi-page onboarding flow.
 * Feature 016: Wraps OnboardingRouter with OnboardingGuard.
 *
 * Guards:
 * - OnboardingGuard: Redirects to home if onboarding already completed
 * - Sequential guards in OnboardingRouter enforce page order
 */

import React from 'react';
import OnboardingGuard from '../components/onboarding/OnboardingGuard';
import OnboardingRouter from './onboarding/OnboardingRouter';

const OnboardingPage: React.FC = () => {
  return (
    <OnboardingGuard>
      <OnboardingRouter />
    </OnboardingGuard>
  );
};

export default OnboardingPage;
